//Edit Container for various measures
import React from 'react'
import { connect } from 'react-redux'
import { collapseLeftToolbar } from '../../../../action/left-toolbar-state-actions'
import Dialog from '../../common/dialog'
import MarkerDetails from '../common/marker-details'
import PhotoDetails from '../common/photo-details'
import ShapeDetails from '../common/shape-details'

class Editable extends Dialog {
  constructor(props) {
    super(props)
  }

  render() {
    if (!this.props.leftToolbarState.editable) {
      return null
    }
    const { measureType } = this.props.leftToolbarState.editable,
      shapes = ['line', 'circle', 'polygon', 'track', 'boundary']
    const { collapseLeftToolbar, mapReference } = this.props
    const onCloseButton = () => {
      collapseLeftToolbar()
    }
    return (
      <div className='left-expanded-content-container'>
        <div className='left-expanded-header-container'>
          <span className='left-expanded-header'>{measureType == 'marker' ? '             ' : `Edit ${measureType}`}</span>
          <div className='default-close left-dialog-close' onClick={onCloseButton}></div>
        </div>
        {
          measureType === 'marker' ? <MarkerDetails /> :
            measureType === 'photo' ? <PhotoDetails /> :
              shapes.indexOf(measureType) !== -1 ? <ShapeDetails /> : null
        }
      </div>
    )
  }
}

const mapStateToProps = state => ({
  leftToolbarState: state.leftToolbarState,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
})

const mapDispatchToProps = dispatch => ({
  collapseLeftToolbar: () => dispatch(collapseLeftToolbar())
})

export default connect(mapStateToProps, mapDispatchToProps)(Editable)
